import React from 'react'
import { Table } from 'antd'
import { NoData, TableContainer } from 'components'
import TransactionsListColumns from 'views/UserManagement/Transactions/Components/TransactionsListColumns'

function TransactionsList({data = [], loading, fetchTransactionDetails }) {
	return (
		<TableContainer>
			{
				<Table
					rowKey={data.date}
					pagination={{ hideOnSinglePage: true }}
					columns={TransactionsListColumns(fetchTransactionDetails)}
					dataSource={data}
					loading={loading}
					locale={{
						emptyText: <NoData />
					}}
				/>
			}
		</TableContainer>
	)
}

export default TransactionsList
